"use strict";
/**
 * @module "ethpm/manifests"
 */
Object.defineProperty(exports, "__esModule", { value: true });
